export const PRICE_BASIS = {
  PER_YEAR: "per_year",
  WHOLE_TERM: "whole_term",
};

export const PRICE_BASIS_LABELS = {
  [PRICE_BASIS.PER_YEAR]: "Per year",
  [PRICE_BASIS.WHOLE_TERM]: "The whole term",
};

const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

/** The message for an amount a price version can't hold, or null. */
export const priceAmountError = (draft, prices, ownIndex = -1) => {
  const amount = String(draft).trim();
  if (!AMOUNT_PATTERN.test(amount) || parseFloat(amount) <= 0) {
    return "Enter a price greater than $0 with at most 2 decimal places.";
  }
  const isDuplicate = prices.some(
    (price, index) =>
      index !== ownIndex && parseFloat(price.amount) === parseFloat(amount)
  );
  return isDuplicate ? "This price already exists on this product." : null;
};

export const formatPrice = amount =>
  `$${parseFloat(amount).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const COST_ERROR =
  "Enter a cost of $0 or more with at most 2 decimal places.";

const isBlank = value => value == null || String(value).trim() === "";

/** Whether a cost input is blank or $0 or more with at most 2 decimals. */
export const isValidCost = value =>
  isBlank(value) || AMOUNT_PATTERN.test(String(value).trim());

/** A cost input as the API expects it: a blank cost is null. */
export const toCostPayload = value =>
  isBlank(value) ? null : String(value).trim();

export const DEFAULT_COST_SUFFIX = {
  [PRICE_BASIS.PER_YEAR]: "per year (1 unit)",
  [PRICE_BASIS.WHOLE_TERM]: "per whole term (1 unit)",
};

/** A product's prices that can be picked on an invoice line, current first. */
export const selectablePrices = product =>
  [...(product?.prices ?? [])]
    .filter(price => price.enabled)
    .sort((a, b) => Number(b.is_current) - Number(a.is_current));
